import { apiUtils } from './apiUtils';

class NotificationAPI {
  async getNotifications(data) {
    const _limit = data?._limit ? `?limit=${data._limit}` : ``;

    const Input = {
      type: 'GET',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/Notifications/GetNotificationList${_limit}`,
      params: {}
    };

    const response = await apiUtils.handleMethod(Input);

    return response;
  }

  async saveNotificationRead(data) {
    const Input = {
      type: 'POST',
      method: `${process.env.REACT_APP_WEBAPI_URL}/api/Notifications/SaveNotificationRead`,
      params: data
    };

    const response = await apiUtils.handleMethod(Input);

    return response;
  }
}

export const notificationAPI = new NotificationAPI();
